<template>
    <div>
        <RemoteTable ref="table" :form="form" :table="table" v-show="id < 0">
            <template #default="{row, property}">
                <el-link type="primary" :underline="false" @click="id = row['id']" v-if="property === 'description'">
                    {{row['description']}}
                </el-link>
                <p v-else-if="property === 'status'">{{$utils.getEnumLabel('status', row['status'])}}</p>
            </template>
        </RemoteTable>
        <Config :id="id" @close="close" v-if="id > -1"></Config>
    </div>
</template>
<script>
    import RemoteTable from "@/components/RemoteTable"
    import Config from "./Config.vue"

    export default {
        components: {
            RemoteTable,
            Config,
        },
        data() {
            return {
                id: -1,
                form: {
                    tools: [
                        {icon: "el-icon-plus", click: () => {this.id = 0;}}
                    ],
                    configs: [
                        {label: "角色", name: "name", type: "input", op: "contains", value: ""}
                    ]
                },
                table: {
                    urlPrefix: "/role",
                    columns: [
                        // {label: "角色", name: "name"},
                        {label: "角色", name: "description"},
                        {label: "状态", name: "status"},
                        {label: "操作", name: "tools", width: 50},
                    ]
                }
            }
        },
        methods: {
            close(reload) {
                this.id = -1;
                if (reload) {
                    this.$refs.table.load();
                }
            }
        }
    }
</script>